<h2 adEl mat-dialog-title>Select Tenant</h2>
<mat-dialog-content adEl>
  <mat-nav-list adEl>
    @if (isAdmin) {
    <mat-list-item adEl="allTenantsItem" (click)="selectAllTenants()">
      <span adEl>All Tenants</span>
    </mat-list-item>
    } @for (tenant of tenants; track $index) {
    <mat-list-item adEl (click)="selectTenant(tenant.id)">
      <span adEl>{{tenant.name}}</span>
    </mat-list-item>
    }
  </mat-nav-list>
</mat-dialog-content>
